export enum REQUEST_DETAIL_NAVLINK_TYPES {
  REQUEST_DETAILS = "REQUEST_DETAILS",
  REVIEWER_REQUEST_DETAILS = "REVIEWER_REQUEST_DETAILS",
}
